import { COUNTRY } from "utils/country";
import useCurrencyFormatter from "utils/hooks/useCurrencyFormatter/useCurrencyFormatter";
import style from './currencySymbol.module.css'

export const RenderCurrency = ({ value = 0, localeCountryCode }) => {
    const typeRenderFormat = [COUNTRY.ES];
    const { formatCurrency } = useCurrencyFormatter();
    const { detailedValues } = formatCurrency({
        value,
        digitsValidation: 7,
    });

    const {
        mainInteger: integer,
        decimalSeparator,
        currencySymbol: symbol,
        cents: decimal,
    } = detailedValues;

    // Validar si el valor es 0,00
    if (
        (Number(value) === 0) ||
        (integer.replace(/[^0-9]/g, '') === '0' && decimal.replace(/[^0-9]/g, '') === '00')
    ) {
        return null;
    }

    return typeRenderFormat.includes(localeCountryCode) ? (
        <>
            <span className={style['principal-number']}>{`${integer}`}</span>
            <sup className={style['decimal']}>{`${decimalSeparator} ${decimal}`}</sup>
            <span className={style['principal-number']}>{symbol}</span>
        </>
    ) : (
        <>
            <span className={style['principal-number']}>{symbol}</span>
            <span className={style['principal-number']}>{`${integer}`}</span>
            <sup className={style['decimal']}>{`${decimalSeparator} ${decimal}`}</sup>
        </>
    );
};
